import initializeParams from "./services/initializeParams";
export default (repositoryInstance) => {
    function getWithParams(url, params = {}, defaultParams = {
        offset: 0,
        limit: 5,
        sortDirection: "DESC",
        sortName: "createdAt",
    }, timeout) {
        const p = initializeParams(Object.assign(Object.assign({}, defaultParams), params));
        return repositoryInstance.get(`${url}?${p.join("&")}`, { timeout });
    }
    function switchActiveStatus(entityName, id) {
        return repositoryInstance.post(`${entityName}/${id}/active-status`);
    }
    function getDefault(entityName) {
        return repositoryInstance.get(`${entityName}/default`);
    }
    return Object.freeze({
        initializeParams,
        getWithParams,
        switchActiveStatus,
        getDefault,
    });
};
//# sourceMappingURL=util.js.map